import {
  Component,
  OnInit,
  Input,
  Renderer2,
  Output,
  EventEmitter,
  ChangeDetectionStrategy
} from '@angular/core';
import {UntypedFormBuilder, UntypedFormGroup} from '@angular/forms';
import { RouteId } from 'src/app/enums/env/routes-id-enum';
import { FiltersKey } from 'src/app/enums/search-key.enum';
import { FilterValue } from 'src/app/interfaces/filtres/filter-interface';
import { BtnActionEnum } from 'src/app/modules/btn-action/enums/btn-action.enum';
import { SearchService } from '../../services/search.service';
import {debounceTime} from 'rxjs/operators';
import {Subject, Subscription} from 'rxjs';

@Component({
    selector: 'app-search-component',
    templateUrl: './search.component.html',
    styleUrls: ['./search.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SearchComponent implements OnInit {
  @Input() filterSearch: FilterValue<FiltersKey.SEARCH>;
  @Input() routeId: RouteId;
  @Input() requestInProce = true;
  topVar = '-10';
  click = true;
  focusout = true;
  searchval: FilterValue<FiltersKey.SEARCH>;
  btnActionEnum = BtnActionEnum;
  active = true;
  beforeVal = '';
  btnDisable = false;
  searchValueSubject = new Subject();

  @Output() seachValChange: EventEmitter<FilterValue<FiltersKey.SEARCH>> = new EventEmitter<FilterValue<FiltersKey.SEARCH>>();
  
  inputId = 'inputValue';
  detailForm: UntypedFormGroup;
  subscription = new Subscription();
  subscriptionClear = new Subscription();

  constructor(
    private fb: UntypedFormBuilder,
    private searchService: SearchService,
    private renderer: Renderer2,
  ) {}

  ngOnInit(): void {
    this.focusout = true;
    this.onSearchValid();
    const filter =  this.searchService.initSearch(this.routeId);
    const searchVal = filter.params?.find((elm) => elm.key === FiltersKey.SEARCH)?.value;
    this.detailForm = this.fb.group({
      searchVal: [searchVal],
    });
    this.searchval = { value: searchVal, key: FiltersKey.SEARCH };
    if (searchVal?.trim()) {
      this.onChangeInputValue(searchVal);
    }
    this.subcribeInputSearch();
    this.subscriptionClear = this.searchService.resetFilterOnChangePage().subscribe();
    this.generateRandomId();
  }
  ngOnDestroy(): void {
    this.subscription.unsubscribe();
    this.subscriptionClear.unsubscribe();
  }

  generateRandomId() {
    this.inputId += Math.floor(Math.random() * 100000000);
  }

  onChangeInputValue(value: any): void {
    if (value && value.length >= 3 || value.length === 0) {
      this.searchval.value = value;
      if (this.click) {
        this.searchService.changeQueryParam<FiltersKey.SEARCH>(this.searchval, this.routeId);
        this.seachValChange.emit(this.searchval);
      }
    }
  }

  onSearchValid() {
    const input = document.getElementById(this.inputId);
    if (input) {
      if (this.click) {
        input.classList.remove('input-search');
        input.classList.add('input-search-clicked');
        this.onFocusIn();
      } else {
        this.onFocusOut();
        input.classList.remove('input-search-clicked');
        input.classList.add('input-search');
      }
    }
  }

  onSubmit() {
    this.searchval.value = this.detailForm.get('searchVal')?.value;
    if (this.click) {
      this.searchService.changeQueryParam<FiltersKey.SEARCH>(this.searchval, this.routeId);
    }
    this.seachValChange.emit(this.searchval);
  }
  onFocusOut() {
    this.focusout = true;
    this.renderer.selectRootElement('#' + this.inputId).blur();
  }

  onFocusIn() {
    this.focusout = false;
    this.renderer.selectRootElement('#' + this.inputId).focus();
  }
  removeSearchVal() {
    this.searchval.value = '';
    this.detailForm.get('searchVal')?.setValue(this.searchval.value);
    this.searchService.changeQueryParam(this.searchval, this.routeId);
    this.seachValChange.emit(this.searchval);
  }

  btnEventReceiver($event: boolean) {
    // il y a eu un click
    if ($event === true) {
      this.click = !this.click;
      this.onSearchValid();
    }
  }

  private subcribeInputSearch() {
    this.subscription = this.detailForm.controls.searchVal.valueChanges.pipe().subscribe((value) => {
      this.stateBtn(value);
      this.searchValueSubject.next(value);
    });
    this.searchValueSubject.pipe(
      debounceTime(1200)
    ).subscribe((value) => {
      this.onChangeInputValue(value);
    });
  }
  stateBtn(value: string) {
    if (value.length > 0 ) {
      this.btnDisable = true ;
    } else {
      this.btnDisable = false;
    }
  }

}
